import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose, graphql, withApollo } from 'react-apollo';
import { withRouter } from 'next/router';
import { uniqBy, cloneDeep } from 'lodash';
import { startOfDay, addDays, format } from 'date-fns';

import buildPath from '../../lib/helpers/restLink';
import updateRouterQuery from '../../lib/updateRouterQuery';
import { defaults as defaultCampsite } from '../../resolvers/campsite';
import { generateShortPartyString } from '../../lib/helpers/party';
import {
  validateOutfitCampsite, validateParty, validateArrivalTime,
  validatePitch,
} from '../../lib/validation/availability';
import { getTotalCost, PITCH_SORT_TYPES, sortPitches } from '../../lib/availability';
import { getBookableDaysFromToday } from '../../lib/campsiteTypes';
import isLoggedIn, { isLoggedInMember } from '../../lib/isLoggedIn';

import Text from '../ui/Text';
import { MessageWarning } from '../ui/Message';
import LoadingSpinner from '../ui/Loading/LoadingSpinner';

import { QuoteCreate } from '../Quote';
import { partyConfig } from '../../config/personType';
import { ids, keys } from '../../config/campsiteTypes';
import { dictionaryItem } from '../../hocs/withDictionary';
import GET_PITCHES from './graphql/getPitches.gql';
import GET_USER from '../../config/graphql/getUser';
import GET_AVAILABILITY_AND_USER_CONFIG from './graphql/getAvailabilityAndUserConfig';
import GET_CONFIGURATION from '../../config/graphql/getConfiguration';
import PLACE_EVENT_TYPES,
{ SINGLE_EVENT_TYPE } from '../../config/eventTypes';
import { isMembershipInBasket } from '../../config/quoteMembershipTypes';
import IbePropTypes from '../../IbePropTypes';
import { RENEWAL_STATUSES } from '../../config/membershipStatus';

import {
  AvailabilityDuration,
  AvailabilityExpandSearch,
  AvailabilityParty,
  AvailabilityPitches,
} from '.';

import AvailabilityGuests from './AvailabilityGuests';
import AvailabilityArrivalTime from './AvailabilityArrivalTime';
import AvailabilityMemberNonMember from './AvailabilityMemberNonMember';
import AvailabilityOutfitDetails from './AvailabilityOutfitDetails';
import AvailabilityAddGuests from './AvailabilityAddGuests';
import ErrorTypeMessage from '../ErrorTypeMessage';
import EventsButtonsWrapper from '../SearchForm/Campsites/EventsButtonsWrapper';

import StyledAvailability, {
  Body,
  CheckboxWrapper,
  CheckboxLabel,
  CheckboxText,
  Header,
} from './Availability.style';
import { DATE_FORMAT_DEFAULT } from '../../config/locale';
import FetchPolicy from '../../constants/FetchPolicy';
import { getErrorElement } from '../../lib/helpers/availability';
import { getIsOverseas } from './helpers';
import Title from '../ui/Title';
import Checkbox from '../ui/Form/Checkbox';
import GET_SITES_CONFIG from '../../config/graphql/getSitesConfig';
import { differenceInDays } from '../../lib/dates';
import InfoIconWithModal from './InfoIconWithModal';
import PartyPitchDates from './modals/PartyPitchDates';
import withNewContentModal from '../../hocs/withNewContentModal';
import theme from '../../styles/config/theme';

class Availability extends Component {
  static propTypes = {
    availabilitySearch: PropTypes.shape({
      calendarFirstCellDate: PropTypes.string,
      data: PropTypes.shape({
        availability: PropTypes.shape({
          pitchTypes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
      }),
      error: PropTypes.shape(IbePropTypes.error),
      loading: PropTypes.bool,
      networkStatus: PropTypes.number,
    }),
    availabilitySearchLoading: PropTypes.bool,
    availabilityTotal: PropTypes.shape({
      error: PropTypes.shape(IbePropTypes.apolloError),
      loading: PropTypes.bool,
      data: PropTypes.shape({
        availability: PropTypes.shape({
          pitchTypes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
      }),
    }),
    closedDateError: PropTypes.shape({
      message: PropTypes.string,
    }),
    disabledForms: PropTypes.bool.isRequired,
    getPitches: PropTypes.shape({
      campsite: PropTypes.shape(IbePropTypes.campsite),
      error: PropTypes.shape(IbePropTypes.apolloError),
      loading: PropTypes.bool,
    }),
    data: PropTypes.shape({
      loading: PropTypes.bool,
      error: PropTypes.shape(IbePropTypes.apolloError),
      dictionary: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    events: PropTypes.arrayOf(PropTypes.shape(IbePropTypes.event)),
    configuration: PropTypes.shape(IbePropTypes.configuration),
    campsiteId: PropTypes.string,
    continued: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.bool]),
    fetchAvailabilitySearch: PropTypes.func.isRequired,
    fetchAvailabilityTotal: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    hasBookings: PropTypes.bool,
    inputDateError: PropTypes.shape({
      message: PropTypes.string,
    }),
    isSharedConfigLoading: PropTypes.bool,
    isSitesConfigLoading: PropTypes.bool,
    loadingAvailability: PropTypes.bool,
    prices: PropTypes.shape({
      count: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.shape({
        error: PropTypes.shape(IbePropTypes.apolloError),
        loading: PropTypes.bool,
      })),
    }),
    onContinueClick: PropTypes.func.isRequired,
    onQueryChange: PropTypes.func.isRequired,
    onSelectEvent: PropTypes.func.isRequired,
    payload: PropTypes.shape(IbePropTypes.quotePayload),
    router: PropTypes.shape(IbePropTypes.router).isRequired,
    updatePayload: PropTypes.func.isRequired,
    query: PropTypes.shape(IbePropTypes.query),
    type: PropTypes.number.isRequired,
    selectedEvent: PropTypes.shape(IbePropTypes.event),
    sitesConfig: PropTypes.shape(IbePropTypes.sitesConfig).isRequired,
    handleMemberNonMemberChange: PropTypes.func.isRequired,
    memberPricesAreSelected: PropTypes.bool.isRequired,
    handleUpdateQuote: PropTypes.func.isRequired,
    product: PropTypes.shape(IbePropTypes.product),
    quote: PropTypes.shape(IbePropTypes.quote),
    user: PropTypes.shape(IbePropTypes.user),
    client: PropTypes.shape(IbePropTypes.client),

  };

  static defaultProps = {
    availabilitySearch: {
      data: {
        availability: {
          pitchTypes: [],
        },
      },
    },
    availabilitySearchLoading: false,
    availabilityTotal: {
      data: {
        availability: {
          pitchTypes: [],
        },
      },
    },
    closedDateError: undefined,
    getPitches: {
      error: false,
      campsite: defaultCampsite.campsite,
    },
    inputDateError: null,
    data: {},
    events: [],
    campsiteId: null,
    continued: false,
    error: false,
    hasBookings: false,
    isSharedConfigLoading: false,
    isSitesConfigLoading: false,
    loadingAvailability: false,
    prices: {
      count: 0,
      data: [],
    },
    query: {},
    product: {},
    configuration: {},
    payload: {},
    selectedEvent: null,
    quote: {},
    user: null,
    client: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      guestsErrata: false,
      fieldFocus: '',
      outfitFieldsTouched: {
        vehicleLength: !!props.payload.outfit.vehicleLength,
        vehicleType: !!props.payload.outfit.vehicleType,
        towLength: !!props.payload.outfit.towLength,
        towType: !!props.payload.outfit.towType,
      },
      outfitLengthErrors: [],
      outfitErrors: [],
      arrivalTimeErrors: [],
      partyErrors: [],
      pitchErrors: [],
      isSubmitted: false,
      sortType: PITCH_SORT_TYPES.PRICE_DEFAULT,
    };
  }

  componentDidMount() {
    // As availability is such a heavy request we need to fetch it manually
    this.props.fetchAvailabilitySearch();
    this.props.fetchAvailabilityTotal();
  }

  handleSortTypeChange = (sortType) => {
    this.setState({ sortType });
  }

  maxCampsitePartyLength = (pitches) => {
    if (!pitches.length) return 0;

    const maxPeopleInCampsite = pitches
      .map(pitch => pitch.maxOccupancy)
      .reduce((acc, cur) => Math.max(acc, cur));

    return maxPeopleInCampsite;
  };

  handleResetDates = async () => {
    const {
      fetchAvailabilityTotal,
      handleChange,
      onQueryChange,
      payload,
      query,
      updatePayload,
    } = this.props;
    const copiedQuery = { ...query };

    const mutatedPayload = cloneDeep(payload);

    mutatedPayload.start = undefined;
    mutatedPayload.end = undefined;

    await updatePayload(mutatedPayload);

    await handleChange({ continued: false });

    await onQueryChange({
      ...copiedQuery,
      start: mutatedPayload.start,
      end: mutatedPayload.end,
    });

    await updateRouterQuery(
      '/sites',
      {
        start: mutatedPayload.start,
        end: mutatedPayload.end,
      },
      'replace',
    );

    await handleChange(mutatedPayload);

    await fetchAvailabilityTotal(mutatedPayload);
  }

  handleCalendarMonthChange = (response) => {
    this.props.handleChange(response, this.props.fetchAvailabilitySearch);
  };

  handleDurationChange = async (duration) => {
    const {
      fetchAvailabilityTotal,
      handleChange,
      onQueryChange,
      payload,
      query,
      updatePayload,
    } = this.props;
    const copiedQuery = { ...query };
    const [start, end] = duration;

    payload.start = start;
    // Note of change: CAMC23D-161 we used to enforce the end to same as start if undefined which
    // is itself invalid with the API. An undefined end is now handled by the UI.
    payload.end = end;

    await updatePayload(payload);

    await handleChange({ continued: false });

    await onQueryChange({
      ...copiedQuery,
      start,
      end,
    });

    await updateRouterQuery(
      '/sites',
      {
        start: payload.start,
        end: payload.end,
      },
      'replace',
    );

    await handleChange(payload);

    await fetchAvailabilityTotal(payload);
  };

  handlePartyChange = async (payload, skipValidation = false) => {
    await this.props.updatePayload(payload);
    const isOverseas = getIsOverseas(this.props.router);
    const partyErrors = skipValidation ? [] : validateParty(payload.partyMembers, true, isOverseas);
    await this.setState({
      partyErrors,
    });

    this.props.fetchAvailabilitySearch();
    this.props.fetchAvailabilityTotal();
  };

  // Merge user outfit with quote payload outfit
  handleUserOutfitChange = async (outfit) => {
    const { payload, updatePayload } = this.props;
    payload.outfit = { ...outfit };
    updatePayload(payload);

    await this.validate(payload);

    this.props.handleChange({ continued: false });
  };

  handleArrivalTimeChange = async (arrivalTime) => {
    const { payload, updatePayload } = this.props;
    payload.arrivalTime = arrivalTime;
    this.setState({
      arrivalTimeErrors: [],
    });
    updatePayload(payload);

    this.props.handleChange({ continued: false });
  };

  handleOutfitBlur = ({ target }) => {
    const { name } = target;
    const { outfitFieldsTouched } = this.state;

    this.setState({
      outfitFieldsTouched: {
        ...outfitFieldsTouched,
        [name]: true,
      },
    });
  };

  // Replace quote payload outfit prop with changed value
  handleOutfitDetailsChange = async (outfit) => {
    const { payload, updatePayload } = this.props;
    payload.outfit = outfit;

    await updatePayload(payload);

    await this.validate(payload);

    this.props.handleChange({ continued: false });
  };

  handlePitchChange = ({ id, maxOccupancy, name } = {}) => {
    const payload = { ...this.props.payload };
    payload.pitchTypeId = id ?? '';

    // If a user has entered a valid pitch, remove any errors
    if (id) {
      this.setState({
        pitchErrors: [],
      });
    }

    this.props.handleChange({
      continued: false,
      payload,
      maxOccupancy,
      pitchName: name,
    });
  };

  handleOutfitLengthError = (errors) => {
    this.setState({
      outfitLengthErrors: [...errors],
    });
  };

  handleSubmit = async () => {
    this.setState({ isSubmitted: true });
    await this.validate(this.props.payload, true);

    const element = getErrorElement();
    if (element) {
      element.focus();
      element.scrollIntoView({ block: 'center' });
      return false;
    }

    return this.props.onContinueClick(true);
  };

  // Get the most recently focused date input field and set it in state
  handleFieldFocus = (name) => {
    this.setState({ fieldFocus: name });
  }

  triggerGuestsErrata = (event) => {
    this.setState({
      guestsErrata: event.target.checked,
    });
  };

  validate = (payload, submit = false) => {
    const { configuration, router, client } = this.props;
    const isOverseas = getIsOverseas(router);
    const outfitErrors = validateOutfitCampsite(
      payload.outfit, isOverseas, configuration, router, client,
    );
    const partyErrors = validateParty(payload.partyMembers, true, isOverseas);
    const arrivalTimeErrors = submit ? validateArrivalTime(payload.arrivalTime) : [];
    const pitchErrors = validatePitch(payload);

    this.setState({
      outfitErrors: [...outfitErrors, ...this.state.outfitLengthErrors],
      partyErrors,
      arrivalTimeErrors,
      pitchErrors,
    });
  };

  getFullDays = (pitches) => {
    const { memberPricesAreSelected } = this.props;

    // Dates in the current availability window where all pitches are full
    const perNightPricingKey = memberPricesAreSelected ? 'memberAvailability' : 'nonMemberAvailability';
    const availabilitySize = pitches?.length > 0
      ? pitches[0].memberAvailability?.length
      : 0;
    const siteFullDates = new Array(availabilitySize ?? 0).fill(null).map((_, dayIndex) => {
      const availabilityOnThisDayAcrossPitches = pitches.map((pitch) => {
        if (!pitch[perNightPricingKey] && !pitch[perNightPricingKey]?.length) return null;
        return pitch[perNightPricingKey][dayIndex];
      });
      return availabilityOnThisDayAcrossPitches.every(
        (dayAvailability) => dayAvailability === null,
      );
    });

    return siteFullDates;
  }

  render() {
    const {
      availabilitySearch,
      availabilitySearchLoading,
      availabilityTotal,
      campsiteId,
      continued,
      disabledForms,
      getPitches,
      data,
      data: { dictionary },
      error,
      hasBookings,
      configuration,
      loadingAvailability,
      isSharedConfigLoading,
      isSitesConfigLoading,
      payload,
      handleMemberNonMemberChange,
      memberPricesAreSelected,
      product,
      router,
      sitesConfig,
      quote,
    } = this.props;

    const {
      outfitErrors,
      outfitFieldsTouched,
      outfitLengthErrors,
      isSubmitted,
      sortType,
    } = this.state;

    const uniqueOutfitErrors = uniqBy([
      ...outfitLengthErrors,
      ...outfitErrors,
    ], 'message');

    const filteredOutfitErrors = isSubmitted
      ? uniqueOutfitErrors
      : uniqueOutfitErrors.filter(({ type }) => {
        if (type === 'outfit') {
          return outfitFieldsTouched.towType;
        }
        return outfitFieldsTouched[type];
      });

    // If any of the queries are still loading
    if (
      loadingAvailability ||
      (!availabilitySearch.networkStatus && !availabilitySearch.error) ||
      availabilitySearch.networkStatus < 7 ||
      getPitches.loading ||
      data.loading ||
      isSharedConfigLoading ||
      !configuration ||
      !sitesConfig ||
      isSitesConfigLoading
    ) {
      return <LoadingSpinner marginTop />;
    }

    if (getPitches.error || !getPitches.campsite) {
      return <ErrorTypeMessage error={getPitches.error} />;
    }

    const { availability } = availabilitySearch.data;

    const pitches = getPitches.campsite.pitches.map(({ __typename, ...pitch }) => {
      const pitchAvailabilitySearch = availability.pitchTypes.find(
        ({ code }) => code === pitch.id,
      );
      const totalCost =
        getTotalCost(availabilityTotal, pitch.id, memberPricesAreSelected);

      const availabilityTotalPitch = availabilityTotal.data.availability.pitchTypes.find(
        pitchType => pitchType.code === pitch.id,
      );

      // This is the data from the AvailabilitySearch costPerNight=false request
      // Runs when the user enters dates
      const parsedAvailabilityTotal = {
        ...availabilityTotalPitch,
        hasLowAvailability: availabilityTotalPitch?.hasLowAvailability?.length
          ? availabilityTotalPitch?.hasLowAvailability.some((value) => value)
          : false,
      };

      return {
        ...pitch,
        ...pitchAvailabilitySearch,
        calendarFirstCellDate: availabilitySearch.calendarFirstCellDate,
        selected: pitch.id === payload.pitchTypeId,
        restrictions: availabilityTotalPitch
          ? availabilityTotalPitch.restrictions
          : null,
        totalCost,
        availabilityTotalPitchData: parsedAvailabilityTotal ?? {},
      };
    }).filter((pitchItem) => {
      const eventType = Number(router.query?.eventType) ||
        PLACE_EVENT_TYPES.TOURING.id;
      const isOverseasCampsite = getPitches.campsite?.type === ids.OVERSEAS_SITE;
      const isOverseas = getIsOverseas(router);
      const onlySingleTypePitches = !getPitches.campsite.pitches.some(
        (pitch) => pitch.eventType !== SINGLE_EVENT_TYPE.id,
      );

      return pitchItem.eventType === eventType ||
        (isOverseas && pitchItem.eventType === SINGLE_EVENT_TYPE.id) ||
        (isOverseasCampsite && pitchItem.eventType === SINGLE_EVENT_TYPE.id) ||
        onlySingleTypePitches;
    });

    const { start, end } = payload ?? {};

    const hasDates = !!start && !!end;

    const pricePerNightKey = memberPricesAreSelected ? 'memberMinPricePerNight' : 'nonMemberMinPricePerNight';
    const totalPriceKey = memberPricesAreSelected ? 'memberAvailabilityTotalPrice' : 'nonMemberAvailabilityTotalPrice';

    // If we have selected dates, then we sort pitches by their total cost, which is what we show
    // on each pitch card.
    const pitchSortKey = hasDates ? totalPriceKey : pricePerNightKey;

    const pitchesWithTotalPricing = pitches.map((pitch) => ({
      ...pitch,
      [totalPriceKey]: pitch?.availabilityTotalPitchData?.[totalPriceKey] ?? null,
    }));

    const sortedPitches = sortPitches(pitchesWithTotalPricing, pitchSortKey, sortType);

    const selectedPitch =
      sortedPitches.find(({ id }) => id === payload.pitchTypeId) || {};

    // Getting any available pitch for member/nonmember pricing radio buttons
    const anyAvailablePitch =
      sortedPitches.find(({ memberMinPricePerNight }) => !!memberMinPricePerNight) ?? {};

    const availabilityTotalCost = availabilityTotal?.[totalPriceKey];
    const noAvailability = !availabilityTotalCost;

    // Party in the form e.g. - 1 Adult, 2 Children, 1 Infant
    const partyString = generateShortPartyString(
      payload.partyMembers,
      configuration?.partyMemberTypes,
    )?.toLowerCase() ?? '';

    // Disabled because its handled by BE
    let invalidDates = false;
    if (
      error &&
      error.networkError &&
      error.networkError.result &&
      error.networkError.result.errorCode === 3
    ) {
      invalidDates = true;
    }

    if (this.props.closedDateError) {
      invalidDates = true;
    }

    // Check outfit vehicle exists and has a length value
    const invalidOutfit =
      !payload.outfit.vehicleType ||
      payload.outfit.vehicleLength === null ||
      Number.isNaN(payload.outfit.vehicleLength);

    // TODO: Find a dynamic way to set the party max amount of type
    partyConfig[0].max = selectedPitch.maxOccupancy;
    partyConfig[1].max = selectedPitch.maxOccupancy - 1;
    partyConfig[2].max = selectedPitch.maxOccupancy - 1;

    const dictionaryMap = Object.assign(
      {},
      ...dictionary.map(obj => ({ [obj.key]: obj.value })),
    );
    const bookableDaysFromToday =
      getBookableDaysFromToday(
        getPitches.campsite.type,
        configuration.products,
        getIsOverseas(router),
      );

    /**
     * @TODO product code or name should be supplied with campsite data
     * at a later date, here we are manually mapping for now.
     */
    const userIsMember = isLoggedInMember(this.props.user) || isMembershipInBasket(quote);
    const isOverseasSite = getPitches.campsite.type === ids[keys.OVERSEAS_SITE];
    const isUkClubSite = getPitches.campsite.type === ids[keys.UK_CLUB_SITES];
    const { isMemberOnly: isMemberExclusive } = getPitches.campsite;

    const nonMemberBookableDate
      = product?.nonMemberBookableDate || configuration.availabilityMaxDate;
    const memberBookableDate = product?.memberBookableDate || configuration.availabilityMaxDate;
    const maxDate = memberBookableDate;
    const minDate = format(
      startOfDay(addDays(new Date(), bookableDaysFromToday)),
      DATE_FORMAT_DEFAULT,
    );
    const eventTypeIds = [...new Set(
      getPitches.campsite.pitches.map(item => item.eventType),
    )];
    const eventType = Number(router.query?.eventType ?? PLACE_EVENT_TYPES.TOURING.id);

    const numberOfNights = start && end
      ? differenceInDays(end, start)
      : null;

    const siteFullDates = this.getFullDays(sortedPitches);

    const isNeutralCalendar = !selectedPitch?.id;

    const pitchHasNoRestrictions = !selectedPitch.restrictions
      || selectedPitch.restrictions?.length === 0;

    const isPitchPricingLoading = availabilityTotal.loading || availabilitySearch.loading;

    return (
      <StyledAvailability>
        {isUkClubSite &&
          <StyledAvailability branded>
            <EventsButtonsWrapper
              activeId={eventType}
              handleButtonClick={this.props.onSelectEvent}
              events={this.props.events}
              eventIds={eventTypeIds}
              quote={this.props.quote}
              center
            />
          </StyledAvailability>
        }

        <Body>
          <Header>
            <Title dictionary={dictionaryItem('AvailabilityDuration')} tag={1} size={4} />
            <InfoIconWithModal modalContent={<PartyPitchDates />} />
          </Header>
          <AvailabilityParty
            data={partyConfig}
            disabled={hasBookings || disabledForms}
            max={this.maxCampsitePartyLength(getPitches.campsite.pitches)}
            maxForCurrentPitch={selectedPitch.maxOccupancy}
            onChange={this.handlePartyChange}
            maxChildAge={selectedPitch.maxChildAge}
            minChildAge={selectedPitch.minChildAge}
            payload={payload}
            dataError={!!this.state.partyErrors?.length}
            productCode={product.productCode}
            isOverseas={isOverseasSite}
            useDob
          />

          {this.state.partyErrors.map(err => (
            <MessageWarning
              key={err.message}
              dictionary={err.message}
            />
          ))}

          <AvailabilityDuration
            availability={availability}
            availabilitySearchLoading={availabilitySearchLoading}
            disabled={disabledForms}
            error={!selectedPitch}
            endDate={payload.end}
            fetchAvailability={this.handleCalendarMonthChange}
            loading={loadingAvailability}
            memberBookableDate={memberBookableDate}
            memberPricesAreSelected={memberPricesAreSelected}
            noAvailability={noAvailability}
            nonMemberBookableDate={nonMemberBookableDate}
            onGoToMemberPrices={handleMemberNonMemberChange}
            onCancelMemberPrices={this.handleResetDates}
            onRequestText={
              dictionaryMap.AvailabilityDuration__OnRequest__Button
            }
            userIsMember={userIsMember}
            handleFieldFocus={this.handleFieldFocus}
            onChange={this.handleDurationChange}
            options={{
              dateRange: true,
              handleFieldFocus: this.handleFieldFocus,
              maxDate,
              minDate,
              months: 1,
              name: 'campsiteAvailability_dateRange',
              showRemainder: true,
              static: true,
            }}
            fieldFocus={this.state.fieldFocus}
            selectedEvent={this.props.selectedEvent}
            selectedPitch={selectedPitch}
            startDate={payload.start}
            inputDateError={!!this.props.inputDateError}
            apiError={!!this.props.error}
            pitches={sortedPitches}
            handlePitchChange={this.handlePitchChange}
            isSubmitted={this.state.isSubmitted}
          />

          {!!this.props.inputDateError && (
            <MessageWarning
              key={this.props.inputDateError.message}
              marginTop
              marginBottom
              dictionary={this.props.inputDateError.message}
            />
          )}

          {!!this.props.closedDateError && (
            <MessageWarning
              key={this.props.closedDateError.message}
              marginTop
              marginBottom
              dictionary={this.props.closedDateError.message}
            />
          )}
        </Body>

        <Body>
          <AvailabilityPitches
            campsiteId={campsiteId}
            disabled={disabledForms}
            end={this.props.router?.query?.end}
            handlePitchChange={this.handlePitchChange}
            loading={loadingAvailability || isSitesConfigLoading}
            memberPricesAreSelected={memberPricesAreSelected}
            pitches={sortedPitches}
            pitchTypeId={payload.pitchTypeId}
            start={this.props.router?.query?.start}
            sortType={sortType}
            handleSortTypeChange={this.handleSortTypeChange}
            partyString={partyString}
            numberOfNights={numberOfNights}
            siteFullDates={siteFullDates}
            pitchErrors={this.state.pitchErrors}
            isNeutralCalendar={isNeutralCalendar}
            pricesLoading={isPitchPricingLoading}
          />
          {this.state.pitchErrors.map(err => (
            <MessageWarning
              key={err.message}
              marginTop
              dictionary={err.message}
            />
          ))}
          {(!userIsMember && !(isOverseasSite || isMemberExclusive)) &&
            !RENEWAL_STATUSES.includes(this.props.user?.membershipStatus) &&
            <AvailabilityMemberNonMember
              memberPrice={selectedPitch?.memberMinPricePerNight
                ?? anyAvailablePitch.memberMinPricePerNight}
              nonMemberPrice={selectedPitch?.nonMemberMinPricePerNight
                ?? anyAvailablePitch.nonMemberMinPricePerNight}
              memberPricesAreSelected={memberPricesAreSelected}
              handleMemberNonMemberChange={handleMemberNonMemberChange}
              loginLink={configuration.loginUrlLink}
              numberOfNights={numberOfNights}
            />
          }
        </Body>

        <Body>
          <AvailabilityOutfitDetails
            disabled={hasBookings || disabledForms}
            maxOutfitLength={
              selectedPitch.maxOutfitLength ||
              configuration.defaultMaxVehicleOverallLength
            }
            error={invalidOutfit}
            onError={this.handleOutfitLengthError}
            onUserOutfitChange={this.handleUserOutfitChange}
            onOutfitBlur={this.handleOutfitBlur}
            onOutfitChange={this.handleOutfitDetailsChange}
            outfit={payload.outfit}
            outfitErrors={filteredOutfitErrors}
            eventType={eventType}
            isOverseas={isOverseasSite}
          />

          {filteredOutfitErrors.map(err => (
            <MessageWarning
              key={err.message}
              marginTop
            >
              {err.message}
            </MessageWarning>
          ))}
        </Body>

        {(selectedPitch.fromArrivalTime > -1 && isUkClubSite) ? (
          <Body>
            <AvailabilityArrivalTime
              start={selectedPitch.fromArrivalTime}
              end={selectedPitch.toArrivalTime}
              onChange={this.handleArrivalTimeChange}
              arrivalTimeErrors={this.state.arrivalTimeErrors}
              value={payload.arrivalTime}
              customStyled={{
                border: `1px solid ${theme.COLOR_GRAY_DARK}`,
              }}
            />
            {this.state.arrivalTimeErrors.map(err => (
              <MessageWarning
                key={err.message}
                marginTop
                dictionary={err.message}
              />
            ))}
          </Body>
        ) : null}

        {product?.showPartStayGuestSection ?
          <>
            <Body>
              <AvailabilityAddGuests />
              <AvailabilityGuests
                payload={payload}
                configuration={configuration}
                onChange={this.props.updatePayload}
                handleUpdateQuote={this.props.handleUpdateQuote}
                validatePayload={this.validate}
                maxLength={Math.max(selectedPitch?.maxOccupancy - payload.partyMembers?.length, 0)}
                maxChildAge={selectedPitch.maxChildAge}
                minChildAge={selectedPitch.minChildAge}
                isOverseas={isOverseasSite}
              />
            </Body>
          </> :
          <Body>
            <Title
              marginBottom
              tag={1}
              size={4}
              dictionary={dictionaryItem('AvailabilityGuests')}
            />

            <CheckboxWrapper>
              <Checkbox
                checked={this.state.guestsErrata}
                disabled={disabledForms}
                id="guests"
                onChange={this.triggerGuestsErrata}
                name="guests"
              />

              <CheckboxLabel htmlFor="guests">
                <CheckboxText
                  dictionary={dictionaryItem('AvailabilityGuests__Label')}
                />
              </CheckboxLabel>
            </CheckboxWrapper>

            {this.state.guestsErrata && (
              <Text
                marginTop
                dictionary={dictionaryItem('AvailabilityGuests__Errata')}
              />
            )}
          </Body>
        }

        {this.props.availabilityTotal.error && (
          <ErrorTypeMessage
            error={this.props.availabilityTotal.error}
            marginBottom
          />
        )}

        {!continued && pitchHasNoRestrictions && !invalidDates && (
          <Body>
            <QuoteCreate
              disabled={disabledForms}
              handleContinueClick={this.handleSubmit}
              loading={isSharedConfigLoading || availabilityTotal.loading}
              payload={payload}
            />

            {data.error && (
              <ErrorTypeMessage errorCode={data.error} marginBottom />
            )}

            {getPitches.error && (
              <ErrorTypeMessage errorCode={getPitches.error} marginBottom />
            )}
          </Body>
        )}

        {(!pitchHasNoRestrictions || invalidDates) && (
          <Body>
            <AvailabilityExpandSearch
              lat={this.props.getPitches.campsite.location.lat}
              lon={this.props.getPitches.campsite.location.lon}
              query={this.props.router.query}
            />
          </Body>
        )}
      </StyledAvailability>
    );
  }
}

export default compose(
  withRouter,
  withApollo,
  graphql(GET_CONFIGURATION, {
    props: ({ data }) => ({
      configuration: data.configuration,
      isSharedConfigLoading: data.loading,
    }),
  }),
  graphql(GET_SITES_CONFIG, {
    props: ({ data }) => ({
      sitesConfig: data.configurationSites,
      isSitesConfigLoading: data.loading,
    }),
  }),
  graphql(GET_USER, {
    options: {
      fetchPolicy: FetchPolicy.CACHE_ONLY,
    },
    props: ({ data }) => ({
      user: data.user,
    }),
    skip: props => !isLoggedIn(),
  }),
  graphql(GET_AVAILABILITY_AND_USER_CONFIG, {
    options: () => ({
      variables: {
        dictionaryKeys: ['AvailabilityDuration__OnRequest__Button'],
        pathBuilder: buildPath('dictionary/find'),
      },
    }),
  }),
  graphql(GET_PITCHES, {
    name: 'getPitches',
    options: ({ campsiteId }) => ({
      variables: {
        id: campsiteId,
        skip: !campsiteId,
      },
    }),
  }),
  withNewContentModal('NeutralCalendar'),
)(Availability);
